import React from 'react';
import "./ShipmentMap.scss";
import "leaflet/dist/leaflet.css";
import { MapContainer, Marker, Popup } from 'react-leaflet';
import ShipmentMapPopup from './ShipmentMapPopup/ShipmentMapPopup';
import { createIcon } from '../../utils/utils';
import CustomTileLayer from './CustomTileLayer/CustomTileLayer';


const ShipmentMap = ({ ports, selectShipment }) => {
  return (
    <div className="ShipmentMap">
      <MapContainer center={[0, 0]} zoom={2} scrollWheelZoom={false} style={{ height: 'inherit' }}>
        <CustomTileLayer />
        {
          Object.entries(ports).filter(([name, attributes]) => attributes && attributes.coordinates !== null && !attributes.coordinates.includes(null)).map(([name, attributes], index) => {
            const iconName = attributes?.shipments?.length > 1 ? 'mix' : attributes?.isPol ? 'pol' : 'pod'
            return (
              <Marker key={index} position={attributes?.coordinates} icon={createIcon(iconName)}>
                <Popup position="right">
                  <ShipmentMapPopup name={name} shipments={attributes?.shipments} selectShipment={selectShipment} />
                </Popup>
              </Marker>
            )
          })
        }
      </MapContainer>
    </div>
  )
};

export default ShipmentMap